export default __webpack_public_path__ + "static/media/beginner.94284b4a.png";